// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"284":"c05f11f0","287":"fab3f4cc","806":"a3dc48cf","912":"f7ce104f","963":"3706b633"}[chunkId] + ".chunk.css";
};